function GAFontTool() {

}

GAFontTool.events = {
    isInit: true,
    
    init: function() {
        var that = this;
        var parent = $("#primary_options_container");

        if (that.isInit) {
            $(parent).on("keypress", ".font-guide-container .font-size, .offset-x, .offset-y, .scale-x, .scale-y, .inner-stroke, .outer-stroke", _.debounce(that.onChangeFontSize, 500));
            $(parent).on("click", ".font-guide-container .reset-btn", that.onReset);
            $(parent).on("click", ".font-guide-container .font-guide-btn", that.showFontGuide);
            $(parent).on("click", ".font-guide-container .apply-btn", that.onApply);
            $(parent).on("click", ".font-guide-container .cancel-btn", that.onCancel);
            $(parent).on("click", ".font-guide-container .save-font-settings", that.saveFontSettings);

            $(parent).on("click", "#console-view-buttons .console-perspective", that.perspectiveConsoleViewsGA);
            $(parent).on("click", "#console-view-buttons .console-perspective-all", that.consoleViewAll);
            that.isInit = false;
        }
        GAFontTool.events.hideButtonPerspective();
    },

    onChangeFontSize: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        GAFontTool.events.applyFontSettings(applicationSettings);
    },

    onReset: function() {
        var _origSizes = ub.data.fontOriginalConfig;
        $('input.font-size').val(_origSizes.pixelFontSize);
        $('input.offset-x').val(_origSizes.offSetX);
        $('input.offset-y').val(_origSizes.offSetY)
        $('input.scale-x').val(_origSizes.scaleX);
        $('input.scale-y').val(_origSizes.scaleY);
        $('input.inner-stroke').val(_origSizes.strokeInner);
        $('input.outer-stroke').val(_origSizes.strokeOuter);
    },

    showFontGuide: function() {
        var _status = $(this).data('status');

        if (_status === 'hidden') {
            ub.showFontGuides();
            $(this).data('status', 'visible');
            $(this).addClass('guideActive');
        } else {
            ub.hideFontGuides();
            $(this).data('status', 'hidden');
            $(this).removeClass('guideActive');
        }
    },

    onApply: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        GAFontTool.events.applyFontSettings(applicationSettings);
    },

    onCancel: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        ub.data.fontOriginalConfig = undefined;
        TextApplication.render(application_code);
    },

    applyFontSettings: function(applicationSettings) {
        var fontSize = $('input.font-size').val();
        var offsetX = $('input.offset-x').val();
        var offsetY = $('input.offset-y').val();
        var scaleX = $('input.scale-x').val();
        var scaleY = $('input.scale-y').val();
        var innerStroke = $('input.inner-stroke').val();
        var outerStroke = $('input.outer-stroke').val();

        ub.create_application(applicationSettings, fontSize, offsetX, offsetY, scaleX, scaleY, innerStroke, outerStroke);
    },

    saveFontSettings: function(evt) {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        if (evt.altKey) {
            ub.funcs.saveFontData(_fontID, _size, applicationID, perspective);
        }
    },

    consoleViewAppGAperspective: function(perspective){
        if (!perspective){return;}
        console.clear();
        var settings = ub.current_material.settings;

        ub.utilities.info('--------' + perspective.toUpperCase() + ' APPLICATIONS CONSOLE VIEW-------');
        _.each(settings.applications, function (app) {

            var _primaryViewObjectScale = ""; var _scaleStr = "";
            var _primaryViewObjectPosition = ""; var _positionStr = "";
            var _views = ub.funcs.getPrimaryViewObject(app.application);

            if (typeof _views === "undefined") { 
                ub.utilities.error('No Primary view set for ' + app.code);
                return;
            }

            if (typeof app.custom_obj !== 'undefined') var _isCustomScale = app.custom_obj.active;

            _.each(app.application.views, function (view) {
                if (view.application.isPrimary === 1) {

                    _primaryViewObject = view;
                    _primaryView = view.perspective;
                    _primaryViewObjectScale = view.application.scale;
                    _primaryViewObjectPosition = view.application.center;

                    return;
                }
            });

            if (typeof _primaryViewObjectScale !== "undefined") {
                 _scaleStr = "{x: " + _primaryViewObjectScale.x + ", y: " + _primaryViewObjectScale.y + "}";

            }
            else {
                var _appObj = ub.objects[_primaryView + '_view']['objects_' + app.code];

                if (typeof _appObj !== "undefined") {
                    var _scale = _appObj.scale;
                    // Add (custom scale) label for embellishment application that uses custom scaling
                    (typeof _isCustomScale === 'undefined' && !_isCustomScale && app.type !== 'embellishments') ? _scaleStr = '{x: ' + _scale.x + ',y: ' + _scale.y + '}' : _scaleStr = '{x: ' + _scale.x + ',y: ' + _scale.y + '} (custom scale)';

                }
                else {
                    _scaleStr = 'scale not set.';
                }
            }

            if (typeof _primaryViewObjectPosition !== "undefined") { 

                _positionStrF =  "{x: " + _primaryViewObjectPosition.x + ", y: " + _primaryViewObjectPosition.y + "}"; 
                _positionStrB = "{x: " + ((_primaryViewObjectPosition.x/2)-3) + ", y: " + (_primaryViewObjectPosition.y/2) + "}"; 
            }

            if (typeof app.pattern_settings !== "undefined" ) {
                _patternPosition = (app.pattern_settings.position.y !== 0) ? app.pattern_settings.position.y : 'none';
            }
              var console_group = _primaryView === perspective ? console.groupCollapsed("#", typeof app.code !== "undefined" ? app.code : "--") : '';
              var console_sub = _primaryView === perspective ? console_group + console.log(JSON.stringify({
                                 Code: "#" + typeof app.code !== "undefined" ? app.code : "--",
                                 View: typeof _primaryView !== "undefined" ? _primaryView : "Undefined",
                                 Type: typeof app.application_type !== "undefined" ? app.application_type : "None",
                                 Rotation: typeof _views.application.rotation !== "undefined" ? _views.application.rotation : 0,
                                 PositionBackend: typeof _positionStrF !== "undefined" ? _positionStrF : "None",
                                 PositionFrontend: typeof _positionStrB !== "undefined" ? _positionStrB : "None",
                                 Fontsize: typeof app.font_size !== "undefined" ? app.font_size : "None",
                                 Colors: typeof app.color_array !== "undefined" ? _.pluck(app.color_array, "color_code").toString() : "None",
                                 Accent: typeof app.accent_obj !== "undefined" ? app.accent_obj.title : "None",
                                 DefaultMascot: typeof _views.application.defaultMascot !== "undefined" ? _views.application.defaultMascot : "None",
                                 Tailsweep: typeof _views.application.flip !== "undefined" ? _views.application.flip === 1 ? "Yes" : "No"  : "No",
                                 DefaultFont: typeof app.font_obj !== "undefined" ? app.font_obj.name : "N/A",
                                 DefaultText: typeof app.text !== "undefined" ? app.text : "N/A",
                                 InksoftDesignID: typeof app.embellishment !== "undefined" ? app.embellishment.design_id : "N/A",
                                 Opacity: typeof app.opacity !== "undefined" ? app.opacity : '100%',
                                 PatternPosition: typeof _patternPosition !== "undefined" ? _patternPosition : "None",
                                 DefaultPattern: typeof app.pattern_obj !== "undefined" ? app.pattern_obj.name : "N/A",
                                 CustomScale: typeof _scaleStr !== "undefined" ? _scaleStr : "None",
                                 Flipped: typeof _views.application.flip !== "undefined" ? _views.application.flip === 1 ? "Yes" : "No"  : "No"
                              }, null, 4)) +  console.groupEnd() : '';
            if(_primaryView === perspective) {return console_sub;} else {return;}
        });
        ub.utilities.info('-----------------------------');
        ub.utilities.info('');
    },

    consoleViewAll: function(){
      console.clear();
      var settings = ub.current_material.settings;

      ub.utilities.info('--------ALL APPLICATIONS CONSOLE VIEW-------');

      _.each(settings.applications, function (app) {

          var _primaryViewObjectScale = ""; var _scaleStr = "";
          var _primaryViewObjectPosition = ""; var _positionStr = "";
          var _views = ub.funcs.getPrimaryViewObject(app.application);

          if (typeof _views === "undefined") { 
              ub.utilities.error('No Primary view set for ' + app.code);
              return;
          }

          if (typeof app.custom_obj !== 'undefined') var _isCustomScale = app.custom_obj.active;

          _.each(app.application.views, function (view) {
              if (view.application.isPrimary === 1) {

                  _primaryViewObject = view;
                  _primaryView = view.perspective;
                  _primaryViewObjectScale = view.application.scale;
                  _primaryViewObjectPosition = view.application.center;

                  return;
              }
          });

          if (typeof _primaryViewObjectScale !== "undefined") {
               _scaleStr = "{x: " + _primaryViewObjectScale.x + ", y: " + _primaryViewObjectScale.y + "}";

          }
          else {
              var _appObj = ub.objects[_primaryView + '_view']['objects_' + app.code];

              if (typeof _appObj !== "undefined") {
                  var _scale = _appObj.scale;
                  // Add (custom scale) label for embellishment application that uses custom scaling
                  (typeof _isCustomScale === 'undefined' && !_isCustomScale && app.type !== 'embellishments') ? _scaleStr = '{x: ' + _scale.x + ',y: ' + _scale.y + '}' : _scaleStr = '{x: ' + _scale.x + ',y: ' + _scale.y + '} (custom scale)';

              }
              else {
                  _scaleStr = 'scale not set.';
              }
          }

          if (typeof _primaryViewObjectPosition !== "undefined") { 

              _positionStrF =  "{x: " + _primaryViewObjectPosition.x + ", y: " + _primaryViewObjectPosition.y + "}"; 
              _positionStrB = "{x: " + ((_primaryViewObjectPosition.x/2)-3) + ", y: " + (_primaryViewObjectPosition.y/2) + "}"; 
          }

          if (typeof app.pattern_settings !== "undefined" ) {
              _patternPosition = (app.pattern_settings.position.y !== 0) ? app.pattern_settings.position.y : 'none';
          }

          console.groupCollapsed("#", typeof app.code !== "undefined" ? app.code : "--");
          console.log(JSON.stringify({
                                 Code: "#" + typeof app.code !== "undefined" ? app.code : "--",
                                 View: typeof _primaryView !== "undefined" ? _primaryView : "Undefined",
                                 Type: typeof app.application_type !== "undefined" ? app.application_type : "None",
                                 Rotation: typeof _views.application.rotation !== "undefined" ? _views.application.rotation : 0,
                                 PositionBackend: typeof _positionStrF !== "undefined" ? _positionStrF : "None",
                                 PositionFrontend: typeof _positionStrB !== "undefined" ? _positionStrB : "None",
                                 Fontsize: typeof app.font_size !== "undefined" ? app.font_size : "None",
                                 Colors: typeof app.color_array !== "undefined" ? _.pluck(app.color_array, "color_code").toString() : "None",
                                 Accent: typeof app.accent_obj !== "undefined" ? app.accent_obj.title : "None",
                                 DefaultMascot: typeof _views.application.defaultMascot !== "undefined" ? _views.application.defaultMascot : "None",
                                 Tailsweep: typeof _views.application.flip !== "undefined" ? _views.application.flip === 1 ? "Yes" : "No"  : "No",
                                 DefaultFont: typeof app.font_obj !== "undefined" ? app.font_obj.name : "N/A",
                                 DefaultText: typeof app.text !== "undefined" ? app.text : "N/A",
                                 InksoftDesignID: typeof app.embellishment !== "undefined" ? app.embellishment.design_id : "N/A",
                                 Opacity: typeof app.opacity !== "undefined" ? app.opacity : '100%',
                                 PatternPosition: typeof _patternPosition !== "undefined" ? _patternPosition : "None",
                                 DefaultPattern: typeof app.pattern_obj !== "undefined" ? app.pattern_obj.name : "N/A",
                                 CustomScale: typeof _scaleStr !== "undefined" ? _scaleStr : "None",
                                 Flipped: typeof _views.application.flip !== "undefined" ? _views.application.flip === 1 ? "Yes" : "No"  : "No"
                              }, null, 4));
          console.groupEnd();
      });

      if (_.size(ub.current_material.settings.applications) === 0) { 
          ub.utilities.info('No Applications set.'); 
      } else {
          ub.utilities.info('');
          ub.utilities.info('Total # of applications: ' + _.size(ub.current_material.settings.applications));
      }
      ub.utilities.info('-----------------------------');
      ub.utilities.info('');
    },

    perspectiveConsoleViewsGA: function(){
        var perspective = $(this).attr('data-perspective');
        if(typeof perspective !== 'undefined'){
            GAFontTool.events.consoleViewAppGAperspective(perspective);
        }
    },

    hideButtonPerspective: function(){
      var settings = ub.current_material.settings;
      var _primaryView = [];
      _.each(settings.applications, function (app) {
        _.map(app.application.views, function (view) {
          _primaryView.push({view: view.perspective});
        });
      });

      var views = _.pluck(_primaryView, "view");

      if(!_.contains(views, "front")){
        $("#console-view-buttons #front").hide();
      }

      if(!_.contains(views, "back")){
        $("#console-view-buttons #back").hide();
      }

      if(!_.contains(views, "left")){
        $("#console-view-buttons #left").hide();
      }

      if(!_.contains(views, "right")){
        $("#console-view-buttons #right").hide();
      }
    }
}